import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/locations',
    name: 'location',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/location/index.vue')
  },
  {
    path: '/locations/create',
    name: 'location-create',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/location/create.vue')
  },
  {
    path: '/locations/:id',
    name: 'location-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/location/edit.vue'),
    props: route => ({ editData: route.params.editData })
  }
]
